import React, { useState, useCallback } from "react";
import Gallery from "react-photo-gallery";
import {Image} from './../../helpers';

import Carousel, { Modal, ModalGateway } from "react-images";
const GalleryItems = (gallery) =>{
    if(typeof gallery=== "object"){
        let items = [];
        Object.keys(gallery).map((item)=>{
            const itm = item.split("_");
            if(itm[1] === "image"){
                if(gallery[item] !==""){
                    const k = itm[0];
                    items.push({
                        src: Image(gallery[item]),
                        width:1,
                        height:1,
                        caption: gallery[`${k}_title`] 
                    });
                } 
            }
            return null;
        });
        return items;
    }
    return {};
}
const PageGallery = (props) => {
  const photos = GalleryItems(props.app.settings.pages.gallery);
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = useCallback((event, { photo, index }) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  }, []);

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };
  return (
    <div className="hero is-fullheight is-white">
        <div className="section">
            <div className="container">
                <Gallery photos={photos} onClick={openLightbox} />
                <ModalGateway>
                    {viewerIsOpen ? (
                    <Modal onClose={closeLightbox}>
                        <Carousel
                        currentIndex={currentImage}
                        views={photos.map(x => ({
                            ...x,
                            srcset: x.srcSet,
                            caption: x.title
                        }))}
                        />
                    </Modal>
                    ) : null}
                </ModalGateway>
              </div>
        </div>
    </div>
  );
}
export default PageGallery;



// WEBPACK FOOTER //
// ./src/components/themes/Gallery.js